import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import CreateAccountForm from '../../components/CreateAccountForm';
import GraphQLError from 'components/GraphQLError';
import {WithSetSignupUserData} from 'api/users/WithSetSignupUserData';


export class ActivateAccount extends React.Component {
    static propTypes = {
        token: PropTypes.string.isRequired,
        onUserAccountActivated: PropTypes.func,
        email: PropTypes.string.isRequired,
        firstName: PropTypes.string,
        lastName: PropTypes.string
    };

    static defaultProps = {
        onUserAccountActivated: () => undefined
    };

    setSignupUserData = (doSetSignupUserData, data) => {
        doSetSignupUserData(data, this.props.token).then(() => {
            this.props.onUserAccountActivated();
        });
    };

    render() {
        return (
            <Fragment>
                <WithSetSignupUserData>
                    {({setSignupUserData, loading, error}) => (
                        error ? <GraphQLError error={error}/>
                            : <CreateAccountForm
                                save={this.setSignupUserData.bind(null, setSignupUserData)}
                                loading={loading}
                                firstName={this.props.firstName}
                                lastName={this.props.lastName}
                                email={this.props.email}/>
                    )}
                </WithSetSignupUserData>
            </Fragment>
        );
    }
}


export default ActivateAccount;
